import { LazyLoadImage } from "react-lazy-load-image-component";
import { useSelector } from "react-redux";


const CardAdsBannerTwoImg = (props) => {

    const { isMobile } = useSelector(state => state.general);

    return (

        <a 
            className="w-full block relative" 
            target="_blank"  
            href={props.data.url !== null && props.data.url !== "" ? props.data.url : '#'} 
            onClick={(e) => {if(e.currentTarget.getAttribute('href') === '#'){e.preventDefault();}}} 
            style={ 
                isMobile ?
                {width: 'calc(100% + 0px)', marginRight: '0px', marginTop: `${props.index === 0 ? '0px' : '16px'}`}
                :
                {width: 'calc(50% - 8px)', marginRight: `${props.index === 0 ? '0px' : '16px'}`, marginTop: '0px'}
            }
            >

            <div>
                <div className="h-full styles_Banner--b__dERtW" style={{borderRadius: '16px', lineHeight: '0'}}>
                    <picture>
                        <LazyLoadImage 
                            className="w-full h-full styles_Banner__image__C8h94 inline-block" 
                            src={props.data.image} 
                            alt={props.data.alt}
                            title={props.data.alt}
                            style={{objectFit: 'cover', borderRadius: '16px'}} />
                    </picture>
                </div>
            </div>
        </a>

    );
}

export default CardAdsBannerTwoImg;